import b from 'b_';
import cx from 'classnames';
import { Text } from 'platform-components';
import React from 'react';

import { CHAR_BOARD_THEME } from './typings';

import './char-board.scss';

interface OwnProps {
    changed?: boolean;
    charInput: string;
    mix?: string;
    theme?: CHAR_BOARD_THEME;
}

const CharBoard = ({ mix, changed, charInput, theme }: OwnProps) => {
    const charArray = charInput && charInput.split('');

    return (
        <div className={cx(b('char-board', { changed }), mix)}>
            {charArray &&
                charArray.map((char, index) => {
                    return (
                        <span className="char-board__value" key={index}>
                            {theme === CHAR_BOARD_THEME.BOLD ? (
                                <Text weight={Text.WEIGHT.M}>{char}</Text>
                            ) : (
                                <Text size={Text.SIZE.XL}>{char}</Text>
                            )}
                        </span>
                    );
                })}
        </div>
    );
};

CharBoard.defaultProps = {
    theme: CHAR_BOARD_THEME.DEFAULT,
};

CharBoard.THEME = CHAR_BOARD_THEME;

export default CharBoard;
